export const BUG_REPORT_FIELDS = [
    'description',
    'steps',
    'expectedResult',
    'actualResult',
] as const;

export type BugReportField = typeof BUG_REPORT_FIELDS[number];

const DEFAULT_REQUIRED_FIELDS = new Set<BugReportField>(BUG_REPORT_FIELDS);

/**
 * Parse the `required` URL query parameter for the public bug report form.
 * Comma-separated field names; defaults to all fields when absent or invalid.
 */
export function parseBugReportRequiredFields(searchParams: URLSearchParams): Set<BugReportField> {
    const param = searchParams.get('required');
    if (!param) {
        return new Set(DEFAULT_REQUIRED_FIELDS);
    }

    const fields = param
        .split(',')
        .map((field) => field.trim())
        .filter((field): field is BugReportField => BUG_REPORT_FIELDS.includes(field as BugReportField));

    if (fields.length === 0) {
        return new Set(DEFAULT_REQUIRED_FIELDS);
    }

    return new Set(fields);
}
